import React from 'react'

const ChatBubble = ({
  message,
  sender = 'You',
  time,
  isOwnMessage = false,
  avatar,
}) => {
  return (
    <div style={{
      display: 'flex',
      justifyContent: isOwnMessage ? 'flex-end' : 'flex-start',
      marginBottom: '1rem'
    }}>
      {!isOwnMessage && avatar && (
        <img src={avatar} alt='avatar' style={{ width: 42, height: 42, borderRadius: '50%', marginRight: 8 }} />
      )}
      <div style={{
        maxWidth: '100%',
        position: 'relative',
        backgroundColor: isOwnMessage ? '#DCF8C6' : '#FFF',
        color: '#333',
        border: '1px solid #ccc',
        padding: '0.75rem 1rem',
        borderRadius: '16px',
        boxShadow: '2px 3px 6px rgba(0,0,0,0.1)',
        fontFamily: `'Comic Neue', cursive`,
        fontSize: '1rem',
        lineHeight: '1.4',
      }}>
        <div style={{ marginBottom: 4, fontSize: '0.85rem', fontWeight: 'bold' }}>
          {sender}
        </div>
        <div>{message}</div>
        <div style={{
          textAlign: 'right',
          fontSize: '0.7rem',
          marginTop: 6,
          opacity: 0.6,
        }}>{time}</div>

        {/* Tail */}
        <div style={{
          position: 'absolute',
          width: 0,
          height: 0,
          borderTop: '10px solid transparent',
          borderBottom: '10px solid transparent',
          top: 10,
          left: isOwnMessage ? 'auto' : -10,
          right: isOwnMessage ? -10 : 'auto',
          borderLeft: isOwnMessage ? '10px solid #DCF8C6' : 'none',
          borderRight: isOwnMessage ? 'none' : '10px solid #FFF',
        }} />
      </div>
    </div>
  )
}

export default ChatBubble
